import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';
import { languagesMap } from 'constants/languages';
import {
  hasPatientProfileCcm,
  hasPatientProfileRpm,
} from 'utils/userTypeHelper';
import { useSelector } from 'react-redux';
import { SmsDashboardTabEnums } from 'infrastructure/enums';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IPatientDetails } from 'infrastructure/hooks/smsDashboard/usePatientInfo';
import type { RootState } from 'store';

interface IProps {
  patientInfo: IPatientDetails | undefined;
}

const MainInfo: React.FC<IProps> = ({ patientInfo }) => {
  const { t } = useTranslation();

  const { currentConversation, conversationType } = useSelector(
    (state: RootState) => state.smsDashboard,
  );

  const isCurrentConversationExist = currentConversation.id !== 0;
  const isRpm = conversationType === SmsDashboardTabEnums.RPM;

  const patientFullNameRpm = (
    <>
      <p>
        {hasPatientProfileRpm(patientInfo?.profile.status!) &&
        patientInfo?.profile.guid ? (
          <Link to={Routes.patientGuid(patientInfo?.profile.guid)}>
            {isCurrentConversationExist &&
              currentConversation.patient.fullNameWithOnlyTitle}
          </Link>
        ) : (
          isCurrentConversationExist &&
          currentConversation.patient.fullNameWithOnlyTitle
        )}
      </p>
    </>
  );
  const patientFullNameCcm = (
    <>
      <p>
        {hasPatientProfileCcm(patientInfo?.profile.ccmStatus!) &&
        patientInfo?.profile.guid ? (
          <Link to={Routes.patientGuid(patientInfo?.profile.guid)}>
            {isCurrentConversationExist &&
              currentConversation.patient.fullNameWithOnlyTitle}
          </Link>
        ) : (
          isCurrentConversationExist &&
          currentConversation.patient.fullNameWithOnlyTitle
        )}
      </p>
    </>
  );

  const info = [
    {
      label: t('labels.primaryNumber'),
      value: patientInfo?.profile.phone,
      visible: isCurrentConversationExist,
    },
    {
      label: t('labels.preferredLanguage'),
      value: languagesMap[`${patientInfo?.profile.language}`] || '',
      visible: true,
    },
    {
      label: t('labels.serviceModel'),
      value: patientInfo?.clinic.serviceDeliveryModel,
      visible: true,
    },
  ];

  return (
    <div className={s.wrapper}>
      <div className={s.name}>
        {isRpm ? patientFullNameRpm : patientFullNameCcm}
      </div>
      {info.map(
        (el, index) =>
          el.visible && (
            <div key={index} className={s.item}>
              <p>{el.label}:</p>
              <p>{el.value}</p>
            </div>
          ),
      )}
    </div>
  );
};

export default MainInfo;
